import { motion } from "motion/react";

type ImagePreviewProps = {
  imageUrl: string;
  onClose: () => void;
};

export function ImagePreview({ imageUrl, onClose }: ImagePreviewProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="fixed inset-0 z-60 flex items-center justify-center p-4 bg-[#0f0f0f]/95 backdrop-blur-sm cursor-zoom-out"
      onClick={onClose}
    >
      <motion.img
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
        src={imageUrl}
        alt="Preview"
        className="max-w-5xl max-h-[85vh] object-contain border border-white/15"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        onClick={onClose}
        className="absolute top-5 right-5 border border-white/15 px-2.5 py-1 text-xs text-white/50 hover:text-white hover:border-white/30 transition-colors duration-200"
      >
        lukk
      </button>
    </motion.div>
  );
}
